export default __webpack_public_path__ + "static/media/ellipse.f016729e.png";